import * as types from './mutation_types'

export default {
  [types.ADD_TIME_DATA](state, { id, time }) {
    state.conceptTimes = {
      ...state.conceptTimes,
      [id]: time
    };
  },
};
